import { styled, vh } from "~/ui/style/stitches.config";
import { useState } from "react";
import { UserProfile } from "~/api/userApi";
import { HelpButtonSmall } from "~/ui/components/HelpButton";
import { ForgotPasswordForm } from "~/ui/components/auth/ForgotPassword";
import ResetPasswordPage from "~/ui/components/auth/ResetPassword";
import { SignupForm } from "~/ui/components/auth/SignUp";
import { SigninForm } from "~/ui/components/auth/Signin";
import SignoutPage from "~/ui/components/auth/Signout";

export enum AuthFormState {
  LOGIN,
  REGISTER,
  FORGOTPASSWORD,
  RESETPASSWORD,
  SIGNOUT,
}

export const AuthPage = ({
  state,
  onlyForms,
  isInBookingFlow,
  price,
  hostUserName,
  onSubmitSignIn,
  redirectDest,
}: {
  state: AuthFormState;
  onlyForms?: boolean;
  isInBookingFlow?: boolean;
  price?: number;
  hostUserName?: string;
  onSubmitSignIn?: Function;
  redirectDest?: string;
}) => {
  const [currState, setCurrState] = useState<AuthFormState>(state);
  const allForms = (
    <>
      {currState === AuthFormState.LOGIN ? (
        <SigninForm
          setAuthState={setCurrState}
          shouldRedirectAfterSignIn={!isInBookingFlow}
          isInBookingFlow={isInBookingFlow}
          onSubmitSignIn={onSubmitSignIn}
        />
      ) : currState === AuthFormState.REGISTER ? (
        <SignupForm
          setAuthState={setCurrState}
          shouldRedirectAfterSignIn={!isInBookingFlow}
          isInBookingFlow={isInBookingFlow}
          price={price}
          hostUserName={hostUserName}
          onSurveySubmit={onSubmitSignIn}
          redirectDest={redirectDest}
        />
      ) : currState === AuthFormState.FORGOTPASSWORD ? (
        <ForgotPasswordForm setAuthState={setCurrState} />
      ) : currState === AuthFormState.SIGNOUT ? (
        <SignoutPage />
      ) : currState === AuthFormState.RESETPASSWORD ? (
        <ResetPasswordPage />
      ) : null}
      <div style={{ position: "fixed", bottom: "20px", right: "20px" }}>
        <HelpButtonSmall />
      </div>
    </>
  );

  return onlyForms ? allForms : <StyledFormPage>{allForms}</StyledFormPage>;
};

export const StyledFormPage = styled("div", {
  width: "100vw",
  height: vh(100),
  display: "flex",
  justifyContent: "flex-start",
  paddingTop: "160px",
  paddingBottom: "60px",
  backgroundColor: "$appBg",
  color: "$text",
  alignItems: "center",
  flexDirection: "column",
  overflowY: "auto",
  position: "relative",
  "@mobile": {
    justifyContent: "flex-start",
    padding: "150px 0 120px 0",
    height: vh(100),
    overflow: "scroll",
    WebkitOverflowScrolling: "touch",
  },
  "& .back-button": {
    position: "absolute",
    top: "20px",
    left: "20px",
    width: "20px",
    transform: "rotate(180deg)",
    cursor: "pointer",
  },
  variants: {
    loaded: {
      false: {
        display: "none",
      },
    },
  },
});

export const StyledClickableText = styled("div", {
  cursor: "pointer",
  fontSize: "12px",

  "&:hover": {
    textDecoration: "underline",
  },
  textAlign: "center",

  variants: {
    lowerText: {
      true: {
        cursor: "pointer",
        fontSize: "16px",
        marginTop: "28px",
        fontWeight: "500",
      },
    },
    link: {
      true: {
        textDecoration: "underline",
        cursor: "pointer",
        "&:hover": {
          opacity: "0.8",
        },
      },
    },
  },
});
